import superMeta from '../_COMMON/metaCommonNode.mjs'

export default {
    ...superMeta,
    name: '程序结构',
    textProp: 'psName',
    type: 'PS',
}
